import { Separator } from "@workspace/web-ui/components/separator";
import { Badge } from "@workspace/web-ui/components/badge";
import { Check } from "lucide-react";
import { formatMedicationDate } from "@workspace/lib/date";
// import { currentMedicationRefills } from "~/features/dashboard/pages/medicals/types";
// import { CurrentProcessing } from "~/features/dashboard/pages/medicals/api/queries/mock";
import { CurrentProcessingMedication } from "../../types";
import { useState } from "react";
import { Paginator } from "./pagination";

interface CurrentRefills {
  currentRefillsItems: CurrentProcessingMedication[];
  totalCount?: number;
}

const ITEMS_PER_PAGE = 5; // Display 5 items per page

export function CurrentRefill({ currentRefillsItems, totalCount }: CurrentRefills) {
  const [currentPage, setCurrentPage] = useState(1);
    // Calculate total pages
    const totalPages = Math.ceil(currentRefillsItems.length / ITEMS_PER_PAGE);

    // Get data for the current page
    const paginatedData = currentRefillsItems.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      currentPage * ITEMS_PER_PAGE
    );

  return (
    <div className="w-full bg-white border rounded-xl shadow-sm mb-4">
      <h3 className="flex items-center text-base sm:text-lg font-medium text-left p-4 sm:p-5 text-[#1A202C]">Currently Processing Medications {totalCount && <Badge className="ml-2 size-4 rounded-full bg-[#4272DD] border border-[#0404041A] p-2 justify-center items-center text-center text-white text-xs">
        {totalCount}
      </Badge>} </h3>
      <Separator />

      <div className="p-3 sm:p-4 space-y-4">
        {paginatedData.map((med, index) => (
          <div key={index} className="border shadow-sm bg-card rounded-[8px] p-3 sm:p-4 bg-white py-4 sm:py-6 px-3 sm:px-6">
            <div className="space-y-2">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
                <h3 className="text-base sm:text-md font-medium text-gray-900">{med.medication} (30-day supply)</h3>
                <h3 className="text-base sm:text-md font-medium text-[#1A202C]">${med.cost}</h3>
              </div>
              <p className="text-xs sm:text-sm text-gray-500">
                Ordered: {formatMedicationDate(med.requested_on)} <span className="mx-2">{"\u2022"}</span>{" "}
                Est. delivery: {formatMedicationDate(med.delivery_date)}
              </p>
            </div>

            {/* Status Steps */}
            <div className="w-full flex items-center justify-between space-x-2 mt-4 overflow-x-auto hide-scrollbar">
              {med?.progress.map((step, idx) => (
                <div key={idx} className="flex space-x-3 relative min-w-[90px]">
                  {step.status === "completed" ? (
                    <div className="flex flex-col space-y-1">
                      <div className="size-6 flex items-center justify-center rounded-full bg-blue-600">
                        <div className="size-3 flex items-center justify-center rounded-full bg-white">
                          <Check className="size-2 text-blue-600" strokeWidth={3} />
                        </div>
                      </div>
                      <span
                        className={`flex flex-col w-14 text-xs font-medium ${step.status === "completed"
                          ? "text-[#4272DD] font-medium"
                          : "text-gray-500"
                          }`}
                      >
                        {step.label}
                        <span>
                          {step.date}
                        </span>
                      </span>
                    </div>
                  ) : (
                    <div className="flex flex-col space-y-1">
                      <div className="size-5 flex items-center justify-center border border-[#0404041A] text-[#464B55] rounded-full text-xs font-medium">
                        {idx + 1}
                      </div>
                      <span
                        className={`flex flex-col w-14 text-xs font-medium ${step.status === "completed"
                          ? "text-[#4272DD] font-medium"
                          : "text-gray-500"
                          }`}
                      >
                        {step.label}
                        <span>
                          {step.date}
                        </span>
                      </span>
                    </div>
                  )}

                  {idx < med?.progress?.length - 1 && (
                    <span className="w-12 sm:w-48 md:w-28 mt-3 border-t border-gray-300 absolute left-5"></span>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <Paginator items={currentRefillsItems} totalPages={totalPages} currentPage={currentPage} onPageChange={setCurrentPage} itemsPerPage={ITEMS_PER_PAGE} className="border-t" />
    </div>
  );
}
